import aurizon from "../../assets/logos/aurizon.png";
import batch from "../../assets/logos/batch-tested.png";
import bigDryFriday from "../../assets/logos/big-dry-friday.png";
import caliba from "../../assets/logos/caliba.png";
import cisco from "../../assets/logos/cisco.png";
import data3 from "../../assets/logos/data3.png";
import echelon from "../../assets/logos/echelon-legal.png";
import governanceByDesign from "../../assets/logos/governance.png";
import integral from "../../assets/logos/integral.png";
import morgans from "../../assets/logos/morgans-financial.png";
import solXenia from "../../assets/logos/sol-xenia.png";
import sunshine from "../../assets/logos/sunshine-coast.png";
import titlesQueensland from "../../assets/logos/titles-queensland.png";
import volvo from "../../assets/logos/volvo.png";
import waddi from "../../assets/logos/waddi.png";
import th7 from "../../assets/logos/TH7.png";
import xenco from "../../assets/logos/xenco-services.png";
import body from "../../assets/logos/body-science.png";
import homes from "../../assets/logos/homes-by-design.png";
import peak from "../../assets/logos/peak.png";
import aon from "../../assets/logos/aon.png";
import gml from "../../assets/logos/gml.png";
import titans from "../../assets/logos/titans.png";

const logos = [
  {
    name: "AON",
    src: aon,
    href: "https://www.aon.com.au/australia/default.jsp",
  },
  { name: "Aurizon", src: aurizon, href: "https://www.aurizon.com.au" },
  { name: "Batch Tested", src: batch, href: "https://www.batchtested.com.au" },
  {
    name: "Big Dry Friday",
    src: bigDryFriday,
    href: "#",
  },
  { name: "Caliba", src: caliba, href: "https://www.caliba.com" },
  { name: "Cisco", src: cisco, href: "https://www.cisco.com" },
  { name: "Data#3", src: data3, href: "https://www.data3.com" },
  { name: "Echelon Legal", src: echelon, href: "https://www.echelon.legal/" },
  {
    name: "Gibson MacNeil Lawyers",
    src: gml,
    href: "https://www.gibsonmacneill.com.au/",
  },
  {
    name: "Governance by Design",
    src: governanceByDesign,
    href: "https://www.governancebydesign.com",
  },
  { name: "Integral", src: integral, href: "https://www.integral.com" },
  { name: "Morgans", src: morgans, href: "https://www.morgans.com.au" },
  { name: "Sol Xenia", src: solXenia, href: "#" },
  {
    name: "Sunshine Coast 2032",
    src: sunshine,
    href: "https://sunshinecoast2032.org.au/",
  },
  {
    name: "Titans",
    src: titans,
    href: "https://www.titans.com.au",
  },
  {
    name: "Titles Queensland",
    src: titlesQueensland,
    href: "https://www.titlesqld.com.au",
  },
  { name: "Volvo", src: volvo, href: "https://www.volvo.com" },
  { name: "Waddi", src: waddi, href: "https://www.waddi.com" },
  { name: "th7", src: th7, href: "https://th7bodylabs.com.au/" },
  { name: "Xenco Services", src: xenco, href: "https://www.xencoservices.com" },
  { name: "Body Science", src: body, href: "https://www.bodyscience.com.au" },
  {
    name: "Homes by Design",
    src: homes,
    href: "#",
  },
  { name: "Peak", src: peak, href: "https://www.peak.app" },
];

// UPDATE WITH NEW IMAGES
export default function Example() {
  return (
    <div className="bg-white py-6 sm:py-32 lg:py-32">
      <div className="mx-auto max-w-7xl lg:px-8">
        <div className="mx-auto grid max-w-lg grid-cols-3 items-center gap-x-4 gap-y- sm:max-w-xl sm:grid-cols-4 sm:gap-x-10 sm:gap-y-14 lg:mx-0 lg:max-w-none lg:grid-cols-6">
          {logos.map((logo) => (
            <a
              key={logo.name}
              href={logo.href}
              target="_blank"
              rel="noopener noreferrer"
              className="col-span-1"
            >
              <img
                alt={logo.name}
                src={logo.src}
                width={200}
                className="max-h-20 w-full object-contain hover:opacity-80 transition-opacity"
              />
            </a>
          ))}
        </div>
        <div className="mt-16 flex justify-center">
          <p className="relative rounded-full bg-gray-50 px-4 py-1.5 text-sm/6 text-gray-600 ring-1 ring-gray-900/5 ring-inset">
            <span className="hidden md:inline">
              We invite you to be part of our our journey to Champion our
              Champions and help leave a lasting legacy.
            </span>
            <a href="#" className="font-semibold text-gold">
              <span aria-hidden="true" className="absolute inset-0" /> Join the
              network <span aria-hidden="true">&rarr;</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
